export const signInDataCy = 'sign-in-button';
